/**
 * Pure `?debug=true` predicate, usable outside React (classifiers, pipelines).
 * `useDebugMode` wraps this for components.
 */
export function isDebugMode(): boolean {
  if (typeof window === 'undefined') return false;
  return new URLSearchParams(window.location.search).get('debug') === 'true';
}
